import React from 'react';
const testimonials = [{
  initials: 'MR',
  quote: 'Compré un domingo. El lunes entré a la cancha con el plan exacto. Nunca más improviso.',
  name: 'Martín R.',
  location: 'Buenos Aires'
}, {
  initials: 'CS',
  quote: 'Tres alumnos que estaban estancados en G4 subieron a G3 en el primer mes.',
  name: 'Carolina S.',
  location: 'Rosario'
}, {
  initials: 'LP',
  quote: 'Mi retención pasó del 40% al 80%. En 4 meses llené todos mis horarios.',
  name: 'Laura P.',
  location: 'Mendoza'
}, {
  initials: 'VT',
  quote: 'Este mes cobré el 100% antes del día 5. Primera vez en mi vida.',
  name: 'Valeria T.',
  location: 'Santa Fe'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-12 px-4" data-id="element-268">
      <div className="max-w-4xl mx-auto" data-id="element-269">
        <h2 className="text-2xl sm:text-3xl font-black text-white text-center mb-8" data-id="element-270">
          Lo que dicen <span className="text-[#00B4D8]" data-id="element-271">+300 profes</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-272">
          {testimonials.map(t => <div key={t.initials} className="bg-black border border-[#00B4D8]/20 rounded-xl p-4 flex items-start gap-3" data-id="element-273">
              <div className="w-9 h-9 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-xs flex-shrink-0" data-id="element-274">
                {t.initials}
              </div>
              <div data-id="element-275">
                <p className="text-white text-sm font-medium mb-1.5 italic" data-id="element-276">
                  "{t.quote}"
                </p>
                <p className="text-gray-500 text-xs" data-id="element-277">
                  — {t.name}, {t.location} ⭐⭐⭐⭐⭐
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}